import request from '../utils/request';
// -----------------------------------------------首 页---------------------------------------------------
//获取首页轮播图
export const gwGetSYLBList = (params) => request.get('/gwGetSYLBList', {params})
// 查询底部信息
export const gwGetBottomInfo = (params) => request.get('/gwGetBottomInfo', {params})
//导航加载tree参数必填语言
export const gwGetMenuList = (params) => request.get('/gwGetMenuList', {params})
//业务板块图片与文字
export const selectGwYwbktp = (params) => request.get('/selectGwYwbktp', {params})
//首页内容标题
export const gwGetHomeInfoTitle = (params) => request.get('/gwGetHomeInfoTitle', {params})
//官网首页查询关于我们信息
export const gwGetHomeAbout = (params) => request.get('/gwGetHomeAbout', {params})
// ---------------------------------------------关 于 我 们---------------------------------------------------
// 查询公司名片集合
export const gwGetCompanyList = (params) => request.get('/gwGetCompanyList', {params})
// ---------------------------------------------业 务 领 域---------------------------------------------------
// 查询业务导航tree
export const gwGetBusinessDHTreeList = (params) => request.get('/gwGetBusinessDHTreeList', {params})
// 查询业务内容根据导航ID与语言类型
export const gwGetBusinessContentList = (params) => request.get('/gwGetBusinessContentList', {params})
// ---------------------------------------------产品中心------------------------------------------------------
//查询全部产品导航
export const getGWProductInfoList = (params) => request.get('/getGWProductInfoList', {params})
// 根据ID查询产品
export const getGWProductInfoListById = (params) => request.get('/getGWProductInfoListById', {params})
//根据ID查询产品详情
export const getGWProductDetailById = (params) => request.get('/getGWProductDetailById', {params})
// ---------------------------------------------新 闻 资 讯---------------------------------------------------
//新闻资讯列表查询根据语言查询
export const getGWClassNewsInfor = (params) => request.get('/getGWClassNewsInfor', {params})
//新闻资讯详情根据语言与ID阅读全文
export const getGWInforNewsDetail = (params) => request.get('/getGWInforNewsDetail', {params})
//分类新闻列表查询
export const getGWClassNewsList = (params) => request.get('/getGWClassNewsList', {params})